// extracted by mini-css-extract-plugin
module.exports = {"viewDownloadsModalWrapper":"qS","header":"qT","headline":"qU","closeIcon":"qV","modalCloseIcon":"qW"};